<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input
            v-model="queryParam.keyWord"
            placeholder="搜索关键字"
            allowClear
          >
            <a-select
              slot="addonBefore"
              v-model="queryParam.searchType"
              placeholder="搜索类型"
              style="width: 120px"
            >
              <a-select-option
                :value="item.id"
                :key="item.id"
                v-for="item in dict.searchTypeDict"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-form-item class="mr-20">
          <a-range-picker v-model="querytimeRange"/>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleExport"
        >导出</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="picture"
          slot-scope="text"
          v-if="text"
        >
          <img
            :src="text"
            @click="handlePreviewPic(text)"
            style="width:64px;height:64px"
          />
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <!-- 查看大图 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      :width="500"
    >
      <img
        alt="example"
        style="width:100%; margin-top:30px"
        :src="previewImage"
      />
    </a-modal>
  </div>
</template>

<script>
import { TcgTable } from '@/components'
import { getRecordList } from '@/api/sale'
import { downloadFile } from '@/utils'

const defaultQueryParam = {
  searchType: 'goods_name'
}

export default {
  name: 'MemberRecodeList',
  components: { TcgTable },
  data() {
    return {
      querytimeRange: [], // 选择时间
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        searchTypeDict: [{ id: 'goods_name', name: '商品名称' }, { id: 'goods_id', name: '商品ID' }, { id: 'security_code', name: '云码' }, { id: 'registrant', name: '登记人' }, { id: 'phone', name: '登记电话' }, { id: 'uid', name: '用户ID' }, { id: 'brand_id', name: '品牌ID' }]
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        if (this.querytimeRange.length) {
          this.queryParam.start_time = this.querytimeRange[0].format('YYYY-MM-DD')
          this.queryParam.end_time = this.querytimeRange[1].format('YYYY-MM-DD')
        } else {
          this.queryParam.start_time = null
          this.queryParam.end_time = null
        }
        return getRecordList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      },
      columns: [
        {
          title: '商品ID',
          dataIndex: 'goods_id'
        },
        {
          title: '商品名称',
          dataIndex: 'goods_name'
        },
        {
          title: '品牌ID',
          dataIndex: 'brand_id'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name'
        },
        {
          title: '云码',
          dataIndex: 'security_code'
        },
        {
          title: '登记人',
          dataIndex: 'registrant'
        },
        {
          title: '登记电话',
          dataIndex: 'phone'
        },
        {
          title: '购买凭证',
          dataIndex: 'picture',
          width: 90,
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: '销售商家',
          dataIndex: 'salesmen'
        },
        {
          title: '购买地点',
          dataIndex: 'buy_address'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        }
      ],
      // 预览图片
      previewVisible: false,
      previewImage: ''
    }
  },
  created () {
    // 查询用户
    if (this.$route.query.uid) {
      this.queryParam.keyWord = this.$route.query.uid
      this.queryParam.searchType = 'uid'
      this.$nextTick(() => {
        this.$refs.table.refresh(true)
      })
    }
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.querytimeRange = []
      this.$refs.table.refresh(true)
    },
    // 预览图片
    handlePreviewPic(pic) {
      this.previewImage = pic
      this.previewVisible = true
    },
    // 导出
    handleExport() {
      // window.location.href = window.location.origin + '/merchant.php/sale_record/outExcel'
      const href = window.location.origin + '/merchant.php/sale_record/outExcel'
      downloadFile(href)
    }
  }
}
</script>
